"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Progress = {
    type: "structure",
    required: [],
    members: {
        BytesScanned: {
            shape: {
                type: "integer"
            }
        },
        BytesProcessed: {
            shape: {
                type: "integer"
            }
        },
        BytesReturned: {
            shape: {
                type: "integer"
            }
        }
    }
};
//# sourceMappingURL=_Progress.js.map